import { Input, Flex, Box, Text, Button, Skeleton } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { memo, useState, useEffect } from "react";
import { BiSearch } from "react-icons/bi";
import { closeModal } from "@mantine/modals";
import { ModalId } from "src/utils/constants";
import {
  useCreateCheckInMutation,
  useGetClientCheckInPageLazyQuery,
} from "src/generated/graphql";
import { useAppContext } from "src/api/AppContext";

function SelectMember() {
  const [search, setSearch] = useDebouncedState("", 500);
  const [selectedClientId, setselectedClientId] = useState("");
  const { currentLocation } = useAppContext();

  useEffect(() => {
    getSearchValues();
  }, [search, currentLocation]);

  const [createCheckIn, { loading: checkInLoading }] = useCreateCheckInMutation(
    {
      onCompleted() {
        closeModal(ModalId.CheckInSelectMember);
      },
    }
  );

  const [getClients, { data, loading }] = useGetClientCheckInPageLazyQuery({
    fetchPolicy: "network-only",
  });

  const handleCheckIn = () => {
    if (!selectedClientId || !currentLocation?.id) return;
    createCheckIn({
      variables: {
        data: {
          client: { id: selectedClientId },
          location: { id: currentLocation.id },
        },
      },
    });
  };

  const getSearchValues = () => {
    getClients({
      variables: {
        pagination: {
          count: 7,
          filters: [
            {
              field: "name",
              type: "text",
              value: search,
              parentRelationField: "user",
            },
            {
              field: "id",
              type: "text",
              value: currentLocation?.id,
              parentRelationField: "locations",
            },
          ],
        },
      },
    });
  };

  return (
    <>
      <Input
        m={"8px"}
        radius={"xl"}
        size="sm"
        icon={<BiSearch />}
        placeholder="Search"
        defaultValue={search}
        onChange={(event) => setSearch(event.currentTarget.value)}
        sx={{
          borderColor: "#EBEBEB",
          input: {
            background: "#F6F6F6",
          },
        }}
      />

      {!data?.clientPage.items.length && (
        <Box mb={"sm"} p={7}>
          {loading ? (
            <Skeleton w="100%" height={60} mb={10} />
          ) : (
            <Text align="center" fw={600} size={18}>
              No Account Found
            </Text>
          )}
        </Box>
      )}

      {data?.clientPage.items.map((c) => (
        <Flex
          key={c.id}
          p={7}
          gap={"xs"}
          sx={{
            background: selectedClientId === c.id ? "#DDDDDD" : "transparent",
            borderBottom: `1px solid #DDDDDD`,
          }}
          onClick={() => setselectedClientId(c.id)}
        >
          <Box
            sx={(theme) => ({
              height: 50,
              width: 50,
              background: theme.colors.gray[2],
              borderRadius: 4,
            })}
          >
            {c.user?.profilePicUrl && (
              <img
                src={c.user.profilePicUrl}
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: 4,
                  maxHeight: 50,
                  maxWidth: 50,
                }}
                alt="profile pic"
              />
            )}
          </Box>
          <Box>
            <Text size={14}>
              {c.user.firstName} {c.user.lastName}
            </Text>
            <Text size={14} fw={500}>
              {c.memberStatus} {c.leadStatus && `- ${c.leadStatus}`}
            </Text>
          </Box>
        </Flex>
      ))}

      <Button
        fullWidth
        mt={"xs"}
        radius={"xl"}
        size="sm"
        onClick={handleCheckIn}
        disabled={!selectedClientId}
        loading={checkInLoading}
      >
        Check In
      </Button>
    </>
  );
}

export default memo(SelectMember);
